import Processing from 'ext-ui/components/Processing/Processing'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectErrorDetailMapFromState,
  selectIsPostingUserFromState,
  selectTopLevelErrorFromState,
} from 'src/app/Signup/redux/signup.selectors'
import { SignupQueryParams } from 'src/app/Signup/signup.types'
import SignupSsoForm from 'src/component-form/SignupSsoForm/SignupSsoForm'
import SignupForm from 'src/components/SignupForm/SignupForm'
import UnauthedBoxContainer from 'src/components/UnauthedBoxContainer/UnauthedBoxContainer'
import UnauthedPageContainer from 'src/components/UnauthedPageContainer/UnauthedPageContainer'
import { useBackgroundDispatch } from 'src/hooks'
import { createSetIsExtraVerificationPopupOpen } from 'src/redux/actions/app.actions'
import {
  createSetEmail,
  POST_USER_SUCCESS,
  postUserAndRedirectToSignin,
} from 'src/redux/actions/auth.actions'
import { selectEmailFromState } from 'src/redux/selectors/auth.selectors'
import { selectQueryParams } from 'src/redux/selectors/router.selectors'
import { PostUserRequest } from 'src/requests/postUser.request'

import style, { boxStyling } from './SignupHalfPage.style'

interface SignupHalfPageProps {
  setShowHowToJoin: (val: boolean) => void
  authConfigLoading?: boolean
  isSsoOrg?: boolean
}

const SignupHalfPage: React.FC<SignupHalfPageProps> = (props) => {
  const email = useSelector(selectEmailFromState)
  const isPostingUser = useSelector(selectIsPostingUserFromState)
  const topLevelError = useSelector(selectTopLevelErrorFromState)
  const errorDetailMap = useSelector(selectErrorDetailMapFromState)
  const queryParams = useSelector(selectQueryParams)

  const dispatch = useBackgroundDispatch()

  const dispatchSetEmail = (val: string): void => {
    dispatch(createSetEmail(val))
  }

  const dispatchPostUser = (body: Partial<PostUserRequest>): void => {
    dispatch(postUserAndRedirectToSignin(body, signupAndJoin)).then(
      (res): void => {
        if (res.type === POST_USER_SUCCESS) {
          dispatch(createSetIsExtraVerificationPopupOpen(true))
        }
      },
    )
  }

  const { orgName, inviteeEmail, inviterName, inviterEmail } = queryParams

  const signupAndJoin = !!(
    orgName &&
    inviteeEmail &&
    inviterName &&
    inviterEmail
  )

  const renderFormContent = () => {
    if (props.authConfigLoading) {
      return <Processing width={48} height={48} />
    }
    if (
      props.isSsoOrg &&
      inviteeEmail &&
      orgName &&
      inviterName &&
      inviterEmail
    ) {
      return (
        <SignupSsoForm
          className={'signupForm'}
          inviteeEmail={inviteeEmail}
          orgName={orgName}
          inviterName={inviterName}
          inviterEmail={inviterEmail}
        />
      )
    }
    return (
      <SignupForm
        className={'signupForm'}
        email={email}
        isPostingUser={isPostingUser}
        topLevelError={topLevelError}
        errorDetailMap={errorDetailMap}
        setEmail={dispatchSetEmail}
        postUser={dispatchPostUser}
        setShowHowToJoin={props.setShowHowToJoin}
        queryParams={queryParams as SignupQueryParams}
      />
    )
  }

  return (
    <UnauthedPageContainer css={style}>
      <UnauthedBoxContainer
        className={'unauthedBoxContainer'}
        boxStyling={boxStyling}
      >
        {renderFormContent()}
      </UnauthedBoxContainer>
    </UnauthedPageContainer>
  )
}

export default SignupHalfPage
